import type { UnpackedFilter } from '../hooks/useMultiFilterEditor';
import { type Filter, type FilterId, isMultiFilter } from '../types/filters';

/**
 * A multi filter as the filter bar chips it: one UnpackedFilter per instance,
 * each knowing its parent and index so a chip can remove just itself. Any
 * other filter is returned as it is.
 */
export const unpackMultiFilter = (
  id: FilterId,
  filter: Filter
): UnpackedFilter[] =>
  isMultiFilter(filter)
    ? filter.instances.map((instance, index) => ({
        ...instance,
        displayId: `${id}_instance_${index}`,
        parentMultiFilterId: id,
        instanceIndex: index,
      }))
    : [filter];
